import { SVGInterface } from "../../interface";

const Check = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M5.60981 9.67011L3.83982 11.4401L10.2598 17.8601L21.5498 6.57005L19.7798 4.80005L10.2598 14.3201L5.60981 9.67011Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Check;
